// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressItem.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';

export default class ImportProgressItem {
  @observable status: number = 0;
  @observable errorCode: number = 0;

  objectName: string = null;
  id: string = null;
  fileKey: string = null;

  constructor(data: any) {
    this.setData(data);
  }

  @action
  setData(data: any) {
    this.objectName = data.objectName;
    this.status = data.status;
    this.errorCode = data.errorCode;
    this.id = data.id;
    this.fileKey = data.fileKey;
  }
}


// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportProgressItem.js